export default "__VITE_ASSET__BFdFu57J__"